import { Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PLAN_NAMES, formatMoney, formatDate } from "@/lib/constants";

function Row({ k, v, testid }) {
  return (
    <div className="flex justify-between gap-4 py-1.5 border-b border-dashed border-[#d1e7dd] last:border-0 text-sm">
      <span className="text-[#4b6b5c]">{k}</span><span className="font-semibold text-[#0b2e20] text-right" data-testid={testid}>{v}</span>
    </div>
  );
}

export function ReceiptView({ r, printable = true }) {
  return (
    <div className="rounded-2xl border-2 border-[#1f5f42] bg-white p-5 relative" data-testid={`receipt-${r.id}`}>
      {r.demo && <span className="absolute top-3 right-3 text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded bg-amber-100 text-amber-700" data-testid="receipt-demo-badge">Демо</span>}
      <div className="font-display font-extrabold text-[#0b2e20]">NIS HUB · Чек</div>
      <div className="text-xs text-[#6b8a7b] mb-3" data-testid="receipt-number">№ {r.number}</div>
      <Row k="Покупатель" v={r.username} />
      <Row k="Тариф" v={`${PLAN_NAMES[r.plan]} · 30 дней`} testid="receipt-plan" />
      <Row k="Сумма" v={formatMoney(r.amount, r.currency)} testid="receipt-amount" />
      <Row k="Оплачено" v={formatDate(r.paid_at)} />
      <Row k="Действует до" v={formatDate(r.valid_until)} testid="receipt-valid-until" />
      <Row k="Код платежа" v={r.code} />
      {r.donation_id && <Row k="ID доната" v={r.donation_id} />}
      {printable && <Button variant="outline" size="sm" onClick={() => window.print()} className="mt-4 rounded-full" data-testid="receipt-print-button"><Printer className="h-4 w-4 mr-1" />Распечатать</Button>}
    </div>
  );
}
